import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { STORAGE_KEYS, StorageService } from 'src/app/services/storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { environment } from 'src/environments/environment';
import * as xml2js from 'xml2js';

@Component({
  selector: 'app-modal-invoice-nota',
  template: `
    <ng-template #modalInvoiceNota let-modal>
      <div class="modal-header">
        <div class="modal-title">Nota de crédito</div>
        <button type="button" class="btn-close" aria-label="Cerrar" [disabled]="loading" (click)="dismiss()"></button>
      </div>
      <div class="modal-body p-4">
        <div class="row">
          <div class="col-md-12">
            <table class="table table-sm mb-3" style="font-size: 0.8em;">
              <thead>
                <tr>
                  <th>Qty.</th>
                  <th class="text-center">Clave</th>
                  <th class="text-center">Importe</th>
                  <th class="text-end">Valor Unitario</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let concepto of conceptos">
                  <td>{{concepto['$']['Cantidad']}}</td>
                  <td class="text-center">{{concepto['$']['ClaveProdServ']}}</td>
                  <td class="text-center">{{concepto['$']['Importe'] | currency}}</td>
                  <td class="text-end">{{concepto['$']['ValorUnitario'] | currency}}</td>
                </tr>
              </tbody>
            </table>
            <form [formGroup]="invoiceNotaForm" (ngSubmit)="createNota()">
              <fieldset [disabled]="loading || invoiceData?.id">
              <div class="form-group required">
                <label for="monto" class="form-label text-sm">Importe sin IVA</label>
                <input id="monto" type="number" min="0.01" step="0.01" class="form-control" formControlName="monto">
                <div *ngIf="ufc['monto'].touched && ufc['monto'].invalid" class="text-danger text-sm">
                  Ingresa un importe mayor a cero, con máximo dos decimales.
                </div>
              </div>
              <div class="form-group required mt-4">
                <label for="metodoPago" class="form-label text-sm">Método de pago</label>
                <select id="metodoPago" class="form-select" formControlName="metodoPago">
                  <option value="" selected>Seleccionar...</option>
                  <option *ngFor="let metodo of metodoPago" [value]="metodo.id">{{metodo.metodo}}</option>
                </select>
                <div *ngIf="ufc['metodoPago'].touched && ufc['metodoPago'].invalid">
                  <div *ngIf="ufc['metodoPago'].errors?.['required']" class="text-danger text-sm">El método de pago es requerido.</div>
                </div>
              </div>
              <div class="form-group required mt-3">
                <label for="formaPago" class="form-label text-sm">Tipo de pago</label>
                <select id="formaPago" class="form-select" formControlName="formaPago">
                  <option value="" selected>Seleccionar...</option>
                  <option *ngFor="let tipo of tipoPago" [value]="tipo.id">{{tipo.tipo}}</option>
                </select>
                <div *ngIf="ufc['formaPago'].touched && ufc['formaPago'].invalid">
                  <div *ngIf="ufc['formaPago'].errors?.['required']" class="text-danger text-sm">La forma de pago es requerido.</div>
                </div>
              </div>   
              <div class="form-group required mt-3">
                <label for="payment_date" class="form-label text-sm">Fecha</label>
                <input id="payment_date" type="date" class="form-control" formControlName="payment_date">
              </div>
              </fieldset>
              <div class="form-group text-end mt-5">
                <button type="button" class="btn btn-outline-secondary me-2" [disabled]="loading" (click)="dismiss()">Cerrar</button>
                <button type="submit" class="btn btn-outline-success" [disabled]="loading">
                  <fa-icon [icon]="icons.faSave" *ngIf="!loading" class="me-2"></fa-icon>
                  <fa-icon [icon]="icons.faCircleNotch" animation="spin" *ngIf="loading" class="me-2"></fa-icon>
                  {{ invoiceData?.id ? 'Descargar nota de crédito' : 'Generar nota de crédito' }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalInvoiceNotaComponent implements OnInit {
  @Input() profile: any;
  @Input() invoice: any;
  @Input() bill: any;
  @Input() conceptos: any;
  @Input() base: any;
  @Input() total: any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalInvoiceNota') modalInvoiceNota !: ElementRef;

  apiUrl: string = environment.AWS_REST_WSPREFIX;
  loading: boolean = false;
  invoiceData: any = {};
  invoiceNotaForm: FormGroup = new FormGroup({});

  tipoPago: any = [
    { id: '01', tipo: 'Efectivo' },
    { id: '02', tipo: 'Cheque nominativo' },
    { id: '03', tipo: 'Transferencia electrónica de fondos' },    
    // { id: '99', tipo: 'Por definir' }
  ];
  metodoPago: any = [
    { id: 'PUE', metodo: 'Pago en una sola exhibición' },
  ];

  cpts: any = [];

  utilityData: any = {};

  parser: any;
  serie: any;
  folio: any;
  receptor: any;
  complemento: any;
  impuestos: any;

  private modalRef: NgbModalRef | undefined;
  storageService = inject(StorageService);
  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public icons: IconsService
  ) {
    const stored = this.storageService.getItem(STORAGE_KEYS.PROFILE);
    this.profile = stored?.profile ?? stored;
  }

  ngOnInit(): void {
    this.buildInvoiceNotaForm();
  }

  get ufc() { return this.invoiceNotaForm.controls; }

  buildInvoiceNotaForm() {
    this.invoiceNotaForm = this.fb.group({
      monto: ['', [Validators.required, Validators.min(0.01), Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      metodoPago: ['', Validators.required],
      formaPago: ['', Validators.required],
      payment_date: ['', [Validators.required]],
    });
  }

  async createNota() {
    if (this.loading) return;
    if (this.invoiceData?.id) {
      this.download();
      return;
    }
    if (this.invoiceNotaForm.invalid) {
      this.invoiceNotaForm.markAllAsTouched();
      this.toastr.error('Por favor, completa el formulario.');
      this.loading = false;
      return;
    }
    if (!this.invoice?.id || !this.invoice?.uuid || !this.bill?.id || !this.profile?.id) {
      this.toastr.error('No se ha cargado la información necesaria de la factura.');
      return;
    }
    this.loading = true;
    try {
      const parsed = await new xml2js.Parser({ trim: true, explicitArray: true }).parseStringPromise(this.invoice.cfdixml);
      const comprobante = parsed?.['cfdi:Comprobante'];
      this.receptor = comprobante?.['cfdi:Receptor']?.[0]?.['$'];
      if (!this.receptor) throw new Error('Invalid invoice');
    } catch {
      this.toastr.error('No fue posible leer los datos de la factura.');
      this.loading = false;
      return;
    }
    

    this.cpts = [
      {
        Cantidad: '1',
        CodigoUnidad: 'ACT',
        CodigoProducto: '84111506',
        Producto: 'Servicios de facturación',
        PrecioUnitario: this.invoiceNotaForm.value.monto,
        Importe: this.invoiceNotaForm.value.monto,
        ObjetoDeImpuesto: '02',
        Impuestos: [
          {
            TipoImpuesto: '1',
            Impuesto: '2',
            Factor: '1',
            Base: this.invoiceNotaForm.value.monto,
            Tasa: '0.160000',
            ImpuestoImporte: this.invoiceNotaForm.value.monto*0.16,
          }
        ]
      }
    ];

    let payload: any = {
      Encabezado: {
        "CFDIsRelacionados": this.invoice.uuid,
        "Fecha": this.invoiceNotaForm.value.payment_date,
        "Serie": 'NC',
        "Folio": this.invoice.folio,
        "MetodoPago": this.invoiceNotaForm.value.metodoPago,
        "FormaPago": this.invoiceNotaForm.value.formaPago,
        "Moneda": "MXN",
        "LugarExpedicion": "26015",
        "SubTotal": this.invoiceNotaForm.value.monto,
        "Total": this.invoiceNotaForm.value.monto*1.16,
        "Receptor": {
          "RFC": this.receptor['Rfc'],
            "NombreRazonSocial": this.receptor['Nombre'],
            "UsoCFDI": 'G02',
            "RegimenFiscal": this.receptor['RegimenFiscalReceptor'],
            "Direccion": {
              "Calle": "",
              "NumeroExterior": "",
              "NumeroInterior": "",
              "Colonia": "",
              "Localidad": "",
              "Municipio": "",
              "Estado": "",
              "Pais": "",
              "CodigoPostal": this.receptor['DomicilioFiscalReceptor']
            }
        }
      },
      Conceptos: this.cpts,
      complemento: {
        serie: 'NC',
        folio: this.bill.id,
        related_invoice: this.invoice.id,
      },
      profile_id: this.profile.id,
    }

    // console.log('PAYLOAD => ', payload);
    this.store.createInvoiceNotaCredito(payload).subscribe({
      next: (res: any) => {
        this.invoiceData = res;
        this.toastr.success('Nota de crédito generada correctamente.', 'Éxito');
        this.updateDismiss.emit();
        this.download();
      },
      error: (err: any) => {
        this.toastr.error('Ocurrió un error al generar la nota de crédito.', 'Error');
        this.loading = false;
      }
    });
  }

  download() {
    this.loading = true;
    const payload = {
      bill: this.bill,
      // dueDate: dueDate,
      // unitData: unitData,
      // buildingData: data,
      invoiceData: this.invoiceData,
      utilityData: this.profile,
      conceptos: this.cpts
    };

    this.store.downloadNota(payload).subscribe({
      next: (data: any) => {
        const int8Array = new Uint8Array(data.result.data);
        const blob = new Blob([int8Array], { type: 'application/pdf' });

        var fileURL = window.URL.createObjectURL(blob);
        var link=document.createElement('a');

        link.href = fileURL;
        link.download = data.filename; // filePath.substr(filePath.lastIndexOf('/') + 1);
        link.click();

        const blob2 = new Blob([this.invoiceData.cfdixml], { type: 'application/xml' });

        var fileURL2 = window.URL.createObjectURL(blob2);
        var link2=document.createElement('a');

        link2.href = fileURL2;
        link2.download = `${this.invoiceData.serie}_${this.invoiceData.folio}.xml`;
        link2.click();

        window.URL.revokeObjectURL(fileURL);
        window.URL.revokeObjectURL(fileURL2);
        this.store.updateInvoice(this.invoiceData.id, { pdf: data.filename }).subscribe({
          next: () => {
            this.loading = false;
            this.dismiss();
          },
          error: () => {
            this.loading = false;
            this.toastr.error('La nota se generó, pero no fue posible guardar la referencia del PDF.');
          }
        });

        return;
      }, error: (error: any) => {
        this.loading = false;
        this.toastr.error('La nota se generó, pero no fue posible descargarla. Puedes reintentar la descarga.');
      }
    });
  }

  openModal(modalContent: TemplateRef<any>) {
    this.buildInvoiceNotaForm();
    this.invoiceData = {};
    this.loading = false;
    this.modalRef = this.modalService.open(modalContent, { backdrop: 'static', keyboard: false });
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
